import InfoIcon from "@mui/icons-material/Info";
import { Checkbox, CircularProgress, FormLabel, Tooltip } from "@mui/material";
import useGlobalContext from "hooks/globalData";
import { EvaluationFormValues } from "pages/EvaluationsPage/EvaluationForm";
import { useEffect } from "react";
import { FormattedMessage as T, useIntl } from "react-intl";
import { useQuery } from "react-query";
import { PrintReferenceRequest } from "services/KnowfullyAdminClient";

type PrintReferenceCheckboxProps = {
  checked?: boolean;
  organizationId: string;
  onChange: (e: any) => void;
  formChange: <T extends keyof EvaluationFormValues>(
    name: T,
    value?: EvaluationFormValues[T]
  ) => void;
};

const PrintReferenceCheckbox = ({
  checked,
  organizationId,
  onChange,
  formChange,
}: PrintReferenceCheckboxProps) => {
  const { formatMessage: t } = useIntl();
  const { applicationInstanceSettingService } = useGlobalContext();

  const { data, isLoading, isError } = useQuery(["enablePrintReference"], () =>
    applicationInstanceSettingService.isPrintReferenceEnabled(
      PrintReferenceRequest.fromJS({
        organizationId,
      })
    )
  );

  const enablePrintReferenceAppInstanceLevel = data?.data!;

  useEffect(() => {
    if (enablePrintReferenceAppInstanceLevel === false) {
      formChange("enablePrintReference", false);
    }
  }, [enablePrintReferenceAppInstanceLevel, formChange]);

  if (isLoading) {
    return <CircularProgress size={16} />;
  }

  if (isError) {
    return (
      <span>
        <T id="fetchError" />
      </span>
    );
  }

  const disabled = !enablePrintReferenceAppInstanceLevel;

  return (
    <>
      <FormLabel>
        <T id="evaluationEnablePrintReferenceLabel" />
      </FormLabel>
      <Checkbox
        checked={enablePrintReferenceAppInstanceLevel && checked}
        onChange={(e) => {
          e.target.checked =
            enablePrintReferenceAppInstanceLevel && e.target.checked;
          onChange(e);
        }}
        disabled={disabled}
      />
      {disabled && (
        <Tooltip
          title={disabled ? t({ id: "printReferenceExamDisabledTooltip" }) : ""}
        >
          <InfoIcon />
        </Tooltip>
      )}
    </>
  );
};

export default PrintReferenceCheckbox;
